import React, { Component } from "react";

class OurCalendars extends Component {
    render() {
        return (
            <div>
                <section className='section cm-services cm-services-02' >
                    <iframe title="week-games" src="https://centrisportivi.gesosport.it/view/#/partitecalendario/settimana/true/flgdisable/true/eyJpZF9zb2NpZXRhIjogNjcsImJhY2tncm91bmRjb2xvciI6IiNGRjAwMDAiLCJjaGFuZ2Vmb290ZXJzdHlsZSI6IHRydWV9" width="100%" height="800px" frameborder="0"></iframe>
                </section >
                <section className='section bg-light-gray cm-services cm-services-02' >
                    <iframe title="month-games" src="https://centrisportivi.gesosport.it/view/#/calendarioiframe/eyJpZF9zb2NpZXRhIjogNjcsImJhY2tncm91bmRjb2xvciI6IiNGRjAwMDAifQ==" width="100%" height="1000px" frameborder="0"></iframe>
                </section >
            </div>
        );
    }
}

export default OurCalendars;

